import { mensajeSimple } from "../components/ui/sweetAlerts";
import { BASE_URL_PRODUCCION } from "../utils/Constants";
const OBTENER_DATOS_RUT_SOLICITANTE_EXITO = "OBTENER_DATOS_RUT_SOLICITANTE_EXITO";
const LOADING = "LOADING"

const dataInicial = {
  dataPersona: {
    rut: "",
    data: {},
    status: ""
  },
  loading: false
}

//reducer
export default function datosPersonaSolicitanteReducer(state = dataInicial, action) {
  switch (action.type) {
    case LOADING:
      return { ...state, loading: true }
    case OBTENER_DATOS_RUT_SOLICITANTE_EXITO:
      return { ...state, dataPersona: action.payload, loading: false }
    default:
      return state;
  }
}

//accion de consumir api
const BASE_URL = BASE_URL_PRODUCCION;
const params = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  }
}

export const obtenerDatosPersonaSolicitanteAction = (rutCompleto, idSolicitud = false) => async (dispatch, getState) => {
  dispatch({ type: LOADING })

  try {
    // Esperar a que el token esté presente en localStorage
    let token = localStorage.getItem('token');
    let intentos = 0;
    while (!token && intentos < 10) {
      await new Promise(res => setTimeout(res, 100));
      token = localStorage.getItem('token');
      intentos++;
    }
    if (!token) {
      mensajeSimple('error', 'No se encontró el token de autenticación.', 3000);
      return false;
    }
    // console.log('JWT token enviado al backend:', token);
    // debugger; // Detener ejecución para inspección
    const url = `${BASE_URL}/verificarpostulante?RutPersona=${rutCompleto}`;
    const paramsConToken = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
    const response = await fetch(url, paramsConToken);
    if (response.status === 500 || response.status === 401) { mensajeSimple('error', 'La sesión ha caducado.', 3000); }

    const responseJSON = await response.json();

    if (responseJSON.status === "info") { mensajeSimple(responseJSON.status, responseJSON.message, 2500); }
    if (!responseJSON.data) { return false; }

    localStorage.setItem("rut", rutCompleto);

    dispatch({
      type: OBTENER_DATOS_RUT_SOLICITANTE_EXITO,
      payload: {
        rut: rutCompleto,
        data: responseJSON.data,
        idSolicitud: idSolicitud,
        status: responseJSON.status,
        message: responseJSON.message
      }
    })

    return true
  } catch (error) {
    console.log("error :", error)
    return false
  }
}